var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecorbTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.898879 6.54751C1.45986 4.98369 2.45744 3.62288 3.76775 2.63403C2.4607 3.7737 1.44159 5.21907 0.796875 6.84754C0.828751 6.74807 0.862221 6.64861 0.898879 6.54751Z",
    fill: "url(#paint0_linear_17732_46885)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18315 3.90592C9.40405 3.89666 10.5946 4.29491 11.5744 5.04028C12.5541 5.78566 13.2696 6.83752 13.6124 8.03641C13.9552 9.23531 13.9066 10.5158 13.4739 11.6839C13.0412 12.852 12.2481 13.8439 11.2148 14.5093C10.1815 15.1746 8.96432 15.4772 7.74779 15.371C6.53126 15.2649 5.38173 14.7559 4.47345 13.9211C3.56517 13.0863 2.94768 11.9714 2.71458 10.7452C2.48149 9.51906 2.6455 8.24858 3.18175 7.12638C3.6915 7.53019 4.31024 7.76395 4.95417 7.796C5.59809 7.82804 6.23609 7.65683 6.78174 7.30555C7.32739 6.95426 7.75432 6.43988 8.0047 5.83209C8.25508 5.22429 8.31682 4.55244 8.18155 3.90755L8.18315 3.90592Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18314 3.90592C9.40405 3.89666 10.5946 4.29491 11.5744 5.04028C12.5541 5.78566 13.2696 6.83752 13.6124 8.03641C13.9552 9.23531 13.9066 10.5158 13.4739 11.6839C13.0412 12.852 12.2481 13.8439 11.2148 14.5093C10.1815 15.1746 8.96432 15.4772 7.74779 15.371C6.53126 15.2649 5.38173 14.7559 4.47345 13.9211C3.56517 13.0863 2.94768 11.9714 2.71458 10.7452C2.48149 9.51906 2.6455 8.24858 3.18175 7.12638C3.6915 7.53019 4.31024 7.76395 4.95417 7.796C5.59809 7.82804 6.23609 7.65683 6.78174 7.30555C7.32739 6.95426 7.75432 6.43988 8.0047 5.83209C8.25508 5.22429 8.31682 4.55244 8.18155 3.90755L8.18314 3.90592Z",
    stroke: "url(#paint1_linear_17732_46885)",
    strokeWidth: 0.354478,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78228 2.62269C4.97452 1.58505 6.37375 0.826126 7.88228 0.398884C9.39082 -0.0283581 10.9723 -0.113622 12.5164 0.149045C13.1437 0.255049 13.7603 0.418775 14.3588 0.638229C16.7993 1.58053 18.833 3.37966 20.0966 5.71433C19.1442 5.69133 18.2022 5.50674 17.309 5.16808C16.5086 4.86689 15.7566 4.44537 15.0777 3.91739C13.7005 2.28183 11.7704 1.23872 9.67359 0.996841C7.57682 0.754961 5.46812 1.33216 3.76953 2.6129L3.78228 2.62269Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.6236C19.3336 18.2017 17.237 20.2178 14.6498 21.2494C12.0626 22.2811 9.1855 22.2482 6.62148 21.1576C4.05745 20.067 2.00552 18.0035 0.895707 15.3993C-0.214107 12.7952 -0.295659 9.8527 0.668142 7.18843C0.709581 7.07592 0.75102 6.96503 0.795647 6.8623C0.25821 8.54554 0.243984 10.3578 0.754929 12.0497C1.26587 13.7415 2.27686 15.2297 3.64871 16.3094C5.02057 17.3891 6.68582 18.0072 8.41522 18.0786C10.1446 18.1499 11.8531 17.6711 13.3055 16.708C14.3476 15.9848 15.5358 15.5117 16.7815 15.324C18.0273 15.1362 19.2984 15.2386 20.5 15.6236Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17732_46885",
    x1: 1.63828,
    y1: 4.49535,
    x2: 2.93108,
    y2: 4.96178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17732_46885",
    x1: 8.20332,
    y1: 15.5619,
    x2: 8.2582,
    y2: 3.74171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorbTab);
export default __webpack_public_path__ + "static/media/recorb-tab.34b8e989136f19e2fc8a3c8eed381c75.svg";
export { ForwardRef as ReactComponent };